import { isAxiosError } from "./backendAxios";

export interface BasicAPIError {
  message: string;
  code: string;
}
export interface ValidationAPIError {
  message: string;
  errors?: {
    errors: string[];
    properties?: Record<string, { errors: string[] }>; // TODO: could type this better with ZodErrorTree
  };
  messages: string[];
  code: "validation-error";
}

export type APIError = BasicAPIError | ValidationAPIError;

export function isUsageExceededError(err: unknown): boolean {
  return (
    isAxiosError(err) &&
    err.response?.status === 429 &&
    err.response.data?.code === "usage-exceeded"
  );
}

export function isValidationAPIError(err: unknown): err is ValidationAPIError {
  if (!err || typeof err !== "object") return false;
  const candidate = err as { code?: unknown; messages?: unknown };
  return candidate.code === "validation-error";
}

export function formatErrorMessage(error: unknown, prefix?: string) {
  let err = error;
  if (isAxiosError(err) && err.response) {
    err = err.response.data;
  }
  if (isValidationAPIError(err)) {
    const joined = Array.isArray(err.messages)
      ? err.messages
          .filter(
            (item): item is string =>
              typeof item === "string" && item.length > 0,
          )
          .join(", ")
      : "";
    const text = joined || (typeof err.message === "string" ? err.message : "");
    if (text) {
      return prefix ? `${prefix}: ${text}` : text;
    }
  }

  if (err && typeof err === "object") {
    const candidate = err as { message?: unknown; code?: unknown };
    if (typeof candidate.message === "string") {
      return prefix ? `${prefix}: ${candidate.message}` : candidate.message;
    }
    if (typeof candidate.code === "string") {
      return prefix ? `${prefix}: ${candidate.code}` : candidate.code;
    }
  }

  return "Unknown Error";
}
